import { Button } from "@aix/ui"
import { createFileRoute } from "@tanstack/react-router"
import { ViralPage2 } from "./-ViralPage2"
import { ViralPage1 } from "./-ViralPage1"

function ViralLandingPage() {
  return <ViralPage2 />
  // return <ViralPage1 />
}

export const Route = createFileRoute("/viral/")({
  component: ViralLandingPage,
})
